export const clientContent = {
  clientName: 'Meridian Tower',
  siteLocation: 'London · Operational handover',
  siteCode: 'MERIDIAN-HQ',
  systemName: 'Pulse',
  tagline: 'Building information',

  seo: {
    home: {
      title: 'Pulse | Meridian Tower Building Information',
      description: 'Find trusted building information, quickly and in context. Assets, drawings, manuals and design records.',
    },
  },

  contact: {
    email: 'support@pulsebuilding.info',
    supportUrl: '#support',
  },
};

